module.exports = __webpack_public_path__ + "media/images/icons/route-02de0c129ce3df1963613d11cbd47fe0.svg";